export default __webpack_public_path__ + "static/media/i_bus-tro_yl_tagless.d50050c2.svg";